import React, { Component } from "react";
import {
  Input,
  Label,
  Select,
  GridColumn,
  GridRow,
  Img,
} from "arv-reactcomponents";
import PropTypes from "prop-types";
import { toJS } from "mobx";
import { inject, observer } from "mobx-react";
import PaymentGateway from "../../PaymentGateway";
import { PAYMENTPAGE } from "npmlinks-constants";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";
import PaymentCard from "../PaymentCard";

@inject("PaymentStore", "NetbankingStore")
@observer
class NetBanking extends Component {
  
  static getList(item) {
    return (
      <li className="nw-common-selectlist" key={item.bankCode}>
        {item.bankName}
      </li>
    );
  }

  constructor() {
    super();
    this.state = {
      // TODO:: put proper state for selected value and handle dropdown title for all banks
      selectedbank: {
        bankCode: 0,
        bankName: PAYMENTPAGE.BANK_DROPDOWNTITLE,
        id: -1,
      },
    };
    this.toggleValue = this.toggleValue.bind(this);
    this.getSelectSelection = this.getSelectSelection.bind(this);
  }

  componentDidMount() {
    Analytics.trackEvent({
      action: Event.action.PAYMENT_NETBANKING_SELECTED,
      category: window.pageType,
    });
  }

  get popularBanks() {
    let { netBankingBanks } = this.props.NetbankingStore;
    if (!netBankingBanks) netBankingBanks = [];
    return netBankingBanks.filter(bank => bank.favourite);
  }
  get allBanks() {
    let { netBankingBanks } = this.props.NetbankingStore;
    if (!netBankingBanks) netBankingBanks = [];
    return netBankingBanks;
  }

  toggleValue(e, clickedBank) {
    if (e.key && e.key !== "Enter") {
      return;
    }
    this.bankSelected(clickedBank);
    this.setState({ selectedbank: clickedBank });
  }

  getSelectSelection(selectedValue) {
    const { selectedbank } = this.state;
    // TODO:: selectedbank is an object be careful to set this values in store
    // in the store we are not storing selected bank
    if (selectedbank !== selectedValue) {
      this.bankSelected(selectedValue);
    }
    this.setState({
      selectedbank: selectedValue,
    });
  }

  bankSelected(selectedValue) {
    const { pgRequestParameters, bankCode, requestedPG, bankName } = selectedValue;
    this.props.NetbankingStore.setSelectedNetbanking({
      bankCode,
      isValid: true,
      pgRequestParameters,
      requestedPG,
    });
    this.props.PaymentStore.setBankSelected();
    Analytics.trackEvent({
      category: window.pageType,
      action: Event.action.PAYMENT_NETBANKING_ENTERED(bankName),
      label: requestedPG,
    });
  }

  get paymentCards() {
    const { selectedbank } = this.state;
    return this.popularBanks.map(bank => {
      const { bankCode, bankName, imageUrl } = bank;
      const selectedClassName =
        (selectedbank.bankCode === bank.bankCode &&
          "nw-paymentcard-selected") ||
        "";
      const isChecked = selectedbank.bankCode === bank.bankCode;
      const paymentCardDetails = {
        name: bankName,
        code: bankCode,
        image: imageUrl,
        className: "netbanking",
        onChange: this.toggleValue,
        isChecked,
        selectedClassName,
        selectedPayment: bank,
      };
      return <PaymentCard.component paymentCardDetails={paymentCardDetails} />;
    });
  }

  render() {
    
    return (
      <div className="nw-netbanking-section">
        <PaymentGateway.component
          success={this.props.NetbankingStore.successWithUserSelectedBank}
          componentName="NetBanking"
        />
        <GridRow className="nw-netbanking-popular">
          <GridColumn className="nw-netbanking-popularlabelcontainer">
            <Label className="nw-netbanking-labels nw-netbanking-popularlabel">
              {PAYMENTPAGE.PAPULARBANKS}
            </Label>
          </GridColumn>
          <GridColumn className="nw-netbanking-popularbanks">
            <GridRow>{this.paymentCards}</GridRow>
          </GridColumn>
        </GridRow>
        <div className="nw-netbanking-all">
          <Label className="nw-netbanking-labels nw-netbanking-alllabel">
            {PAYMENTPAGE.ALLBANKS}
          </Label>
          <div className="nw-netbanking-allbanks">
            <Select
              className="nwc-grid-col-sm-6 nwc-grid-col-md-6 nwc-select-sm nw-netbanking-dropdown nw-common-select"
              selectedValue={this.state.selectedbank.bankName}
              inpList={this.allBanks}
              getSelection={this.getSelectSelection}
              renderList={NetBanking.getList}
              />
          </div>
          <p className="nw-netbanking-redirectmsg">
            {PAYMENTPAGE.NETBANKING_REDIRECTION_MSG}
          </p>
        </div>
      </div>
    );
  }
}
NetBanking.wrappedComponent.propTypes = {
  NetbankingStore: PropTypes.shape({
    success: PropTypes.shape({}).isRequired,
    setSelectedNetbanking: PropTypes.func.isRequired,
    successWithUserSelectedBank: PropTypes.shape({}).isRequired,
    netBankingBanks: PropTypes.shape({}).isRequired,
  }).isRequired,
  PaymentStore: PropTypes.shape({
    setBankSelected: PropTypes.func.isRequired,
  }).isRequired,
};
const getFinalComponent = component =>
  inject("PaymentStore", "NetbankingStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: NetBanking.wrappedComponent,
  component: NetBanking,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PaymentWallet/NetBanking/index.js